module.exports = __webpack_public_path__ + "static/media/blue@2x.e29e87d7.jpg";